export const EQUIPMENT_QR = {
    ENABLED : 1,
    DISABLED : 0
}